<template>
    <r-e-dialog title="修改人员" :visible.sync="dialogVisible" show-footer @click-submit="handleSubmitPublish"
                @click-cancel="handleCancel" @close="handleCancel" width="600px">
        <el-form ref="formPublish" label-width="110px" size="small" :model="formPublish" :rules="rules">
            <el-form-item label="姓名" prop="name">
                <el-input v-model="formPublish.name" placeholder="请填写姓名" />
            </el-form-item>
            <el-form-item label="手机" prop="phone">
                <el-input v-model="formPublish.phone" type="number" placeholder="请填写手机号码"/>
            </el-form-item>
            <el-form-item label="人员类型"  prop="" >
                        <div style="width: 250px;">
                            <el-select v-model="formPublish.type" placeholder="请选择" style="width: 100%;">
                                <el-option label="中介" value="中介"/>
                                <el-option label="装修/软装" value="装修/软装"/>
                                <el-option label="施工" value="施工"/>
                                <el-option label="其他" value="其他"/>
                            </el-select>
                        </div>
                    </el-form-item>
            <el-form-item label="所属单位" prop="company">
                <el-input v-model="formPublish.company"  placeholder="请填写单位名称" />
            </el-form-item>
        </el-form>
    </r-e-dialog>
</template>

<script>
    import { MessageSuccess, MessageWarning } from "@custom/message";
    import { saveAticity,getProceedsPayTotalAp} from "@/api/activity-management";
    import { modifier } from "@/api/staff-management"
    import { ParseIntFormat} from "@custom/index";
    export default {
        name: "modifyPage",
        data() {
            return {
                dialogVisible: false,
                formPublish: {},
                rules: {
                    name: [{required: true, message: '姓名不能为空', trigger: 'blur'}],
                    phone: [{required: true, message: '手机号不能为空', trigger: 'blur'}],
                    type: [{required: true, message: '人员类型不能为空', trigger: 'blur'}],
                    company: [{required: true, message: '单位名称不能为空', trigger: 'blur'}],
                },
                loadingOptions: {
                    lock: true,
                    text: "Loading...",
                    spinner: "el-icon-loading",
                    background: "rgba(0, 0, 0, 0.7)"
                },
            }
        },
       
        methods: {
            layerAddEditCommunityInit(row) {
                // 页面初始化，父页面传递数据
                this.dialogVisible = true;
                this.editCommunityInit(row);
            },
            editCommunityInit(row) {
                // 编辑页面回显数据
                this.formPublish = row;
            },
            
            handleSubmitPublish() {
                let that = this;
                // 表单提交
                that.$refs["formPublish"].validate((valid) => {
                    if (valid) {
                        let {uuid,name, phone, type, company}  = that.formPublish;
                        // phone = ParseIntFormat(phone);
                        const loadingOptions = that.loadingOptions;
                        const loading = that.$loading(loadingOptions);
                        let data = {uuid,name, phone, type, company};
                        modifier(data).then(res => {
                            MessageSuccess("修改成功");
                            that.handleCancel();
                        }).finally(()=>loading.close());
                    } else MessageWarning("请填写必填值", 1000);
                });

            },
            handleCancel() {
                this.dialogVisible = false;
                this.formPublish = {
                    uuid:'',
                    name: '',
                    company: '',
                    phone: '',
                    type: [],
                }
                //2023/05/17 调用父组件方法 刷新修改列表
                this.$emit('getHydropower');
            },
        },
        watch:{}
    }
</script>

<style lang="scss" scoped>
    .el-select {
        width: 100%;
    }

    .flex {
        display: flex;

        /deep/ .el-form-item {
            flex: 1;
            white-space: nowrap;
        }

        /deep/ .tag-group {
            white-space: normal;

            .el-tag {
                margin: 0 VW(5px) VH(5px) 0;
                cursor: pointer;
            }
        }

        /deep/ .samplePhotos {
            white-space: normal;
        }
    }
</style>